import { useEffect, useRef } from 'react'
import { Check, Minus } from 'lucide-react'
import './Checkbox.css'

/**
 * @param {boolean} [indeterminate]  some, not all — a select-all over a partly
 *   chosen list. Only the DOM property carries it (there is no attribute), so it
 *   is set on the element; a click still resolves it to checked or not.
 */
export default function Checkbox({ id, checked, onChange, disabled = false, indeterminate = false, children }) {
  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate
  }, [indeterminate])

  return (
    <label className={`checkbox${disabled ? ' checkbox--disabled' : ''}`} htmlFor={id}>
      <input
        ref={inputRef}
        id={id}
        type="checkbox"
        className="checkbox__input"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      <span className="checkbox__box" aria-hidden="true">
        {indeterminate ? <Minus size={13} strokeWidth={3.5} /> : <Check size={13} strokeWidth={3.5} />}
      </span>
      <span className="checkbox__label">{children}</span>
    </label>
  )
}
